import React from "react";
import { usePermissions } from "../../provider/PermissionProvider";
import AppDownPage from "./AppDownPage";

const AppDownGate = ({ children }) => {
    const { isAppDown } = usePermissions();

    if (isAppDown) {
        return <AppDownPage />;
    }

    return children;
};

export default AppDownGate;